/**
 * Utah's inspector forms for inspector.ts (the crosswalk). Utah counties print their own inspection forms and we don't have their
 * text (inspectionform.ts note; ut/inspectionform.ts): none is mapped, so the screens show the FDA model form and say so.
 */
import type { InspectorStateDef } from "../../inspector.ts";

export const INSPECTOR_UT: InspectorStateDef = { forms: [] };
